'use client';

import { useTheme, type Theme } from '@/src/lib/use-theme';

const OPTIONS: ReadonlyArray<{ value: Theme; label: string; aria: string }> = [
  { value: 'light', label: '☀ Hell', aria: 'Light Theme' },
  { value: 'system', label: '⚙ System', aria: 'System Theme' },
  { value: 'dark', label: '☾ Dunkel', aria: 'Dark Theme' },
];

export function ThemeToggle() {
  const { theme, setTheme, isReady } = useTheme();
  if (!isReady) return null;

  return (
    <div
      role="radiogroup"
      aria-label="Theme auswählen"
      data-tour="theme-toggle"
      className="inline-flex items-center rounded-[var(--k-radius-md)] border border-[var(--k-color-border-default)] bg-[var(--k-color-surface)] p-0.5"
    >
      {OPTIONS.map((option, index) => {
        const isActive = theme === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={option.aria}
            tabIndex={isActive ? 0 : -1}
            onClick={() => setTheme(option.value)}
            onKeyDown={(event) => {
              let nextIndex: number;
              if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % OPTIONS.length;
              else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index + OPTIONS.length - 1) % OPTIONS.length;
              else if (event.key === 'Home') nextIndex = 0;
              else if (event.key === 'End') nextIndex = OPTIONS.length - 1;
              else return;
              event.preventDefault();
              setTheme(OPTIONS[nextIndex].value);
              event.currentTarget.parentElement?.querySelectorAll<HTMLButtonElement>('[role="radio"]')[nextIndex]?.focus();
            }}
            className={`px-2 py-1 text-xs font-semibold rounded transition ${
              isActive
                ? 'bg-[var(--k-color-accent)] text-[var(--k-color-text-on-accent)]'
                : 'text-[var(--k-color-text-secondary)] hover:text-[var(--k-color-text-primary)]'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
